import React from "react";
import styles from "./styles.module.css";

const MaintenancePage = () => {
  return (
    <div className={styles.maintenanceContainer}>
      <div className={styles.maintenanceContent}>
        <img
          src="/maitenance.png"
          alt="در حال بروزرسانی"
          className={styles.maintenanceIcon}
        />

        <h1 className={styles.maintenanceTitle}>در حال بروزرسانی...</h1>

        <p className={styles.maintenanceText}>
          با عرض پوزش به دلیل عملیات توسعه و ارتقای زیرساخت سایت موقتا در دسترس نمی‌باشد.
        </p>

        <div className={styles.maintenanceDots}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
